import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  updateRoleID(event) {
    const positionId = event.target.value
    if (positionId) {
      fetch(`/positions/${positionId}/roleid`, { 
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        }
      })
      .then(response => response.text())
      .then(html => {
        console.log("html hander ")
        console.log(html)
        Turbo.renderStreamMessage(html)
      })
      .catch(error => {
        console.error("Error:", error)
      })
    }
  }
} 